namespace $.$$ {
	export class $shm_hitalama_guide_text extends $.$shm_hitalama_guide_text {
		override uri_resolve( uri: string ) {
			const id = this.$.$shm_hitalama_guide_markdown.page_id(uri)
			return id ? this.page_uri(id) : super.uri_resolve(uri)
		}
	}
}
